// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

// Account data : clear demo data dialog
var AccountDataSettingsDialogController = function ($scope, $modalInstance) {

    $scope.items = {CustomerRelatedData: false, ProductData: false};
    $scope.isValid = true;

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.ok = function () {
        if ($scope.validate()) {
            $modalInstance.close({data: getData()});
        }
    };

    $scope.$watch('items.ProductData', function () {
        if ($scope.items.ProductData) {
            if (!$scope.items.CustomerRelatedData) {
                $scope.items.CustomerRelatedData = true;
            }
        } else {
            $scope.items.CustomerRelatedData = false;
        }
    });

    $scope.$watch('items.CustomerRelatedData', function () {
        if (!$scope.items.CustomerRelatedData) {
            $scope.items.ProductData = false;
        }
    });


    $scope.validate = function () {
        return $scope.isValid = $scope.items.CustomerRelatedData || $scope.items.ProductData;
    };

    function getData() {
        var items = angular.copy($scope.items);
        for (var i in items) {
            if (!items[i]) {
                delete items[i];
            }
        }
        return items;
    }
};
AccountDataSettingsDialogController.$inject = ['$scope', '$uibModalInstance'];
